import { FC, memo } from 'react';
import { Redirect, Route } from 'react-router-dom';
import indexOf from 'lodash/indexOf';

import { RootState } from 'App';
import { resolvedConditionsSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import withDocumentTitle from 'hocs/withDocumentTitle';

const PrivateRoute: FC<any> = ({ component: Component, conditions, redirects = [], search, ...rest }) => {
  const resolvedConditions: boolean[] = useTypedSelector((state: RootState) =>
    resolvedConditionsSelector(state, conditions),
  );
  const redirect: string = redirects[indexOf(resolvedConditions, false)];

  return (
    <Route
      {...rest}
      render={(props) => !redirect
        ? <Component {...props} />
        : <Redirect to={{ pathname: redirect, search }} />}
    />
  );
};

export default withDocumentTitle(memo(PrivateRoute));
